import React, { Component } from 'react';
import {List, Avatar, Button, Form, Select, message, Modal, Input} from 'antd';
import {lapsapicalllogs} from '../../stores/APIEndpoints';
import {booleanAsString, toUrlParams} from "../../stores/Util";
import looseLeafStore from "../../stores/LooseLeafStore";
import DashboardStore from '../../stores/DashboardStore';
import {appStore} from '../../stores/AppStore';
import {inject, observer} from 'mobx-react';
import '../../../src/index.css';
import moment from 'moment';
let slectmulDates = [];
@inject('dataStore')
@observer
class LooseLeafLapsCallLogs extends Component {
  
    constructor(props) {
        super(props);
        this.apiProxy = appStore.apiProxy;
       this.state = {
         payload : ""
        
        };
    }
    get store() {
        return DashboardStore;
      
    }
    async componentDidMount() {
      const lapsId = this.store.currentData.lapsId;
      const url = lapsapicalllogs.replace('{lapsId}',lapsId);
      const response =  await this.apiProxy.getAsync(url);
      const data = await response.json();
      this.setState({payload:data});
      }  
   
 
  render() {
  
     const data = this.store.currentData;
     const title = data.id === undefined ? "New Title" : data.abbreviation + " - " + data.publication;
     const { payload } = this.state;
    return (
        <div>
      {payload != "" ? payload.map(value => <div>
        <pre>{value.requestType}, {moment(value.requestTime).format('DD-MM-YYYY hh:mm:ss')}, {value.responseMessage}</pre>
        </div>) : <pre>No data available</pre>}
      </div>
    );
  }
}

export default Form.create({ name: 'normal_login' })(LooseLeafLapsCallLogs);

// export default WrappedNormalLoginForm;

